module.exports = __webpack_public_path__ + "img/performanceOfDiamonds@2x.e7fa999.jpg";